<template>
    <MuvalBanner
        type="neutral"
        inline
        data-testid="locked-editing-banner"
    >
        Editing is locked. To make any changes to your move please contact {{ contactName }}.
    </MuvalBanner>
</template>

<script setup>
import { useAppStore } from '@/store';

// Shown in the move edit forms while staff have locked the order (CU-14zcqntn47u). Names the mover,
// falling back to "us" when the portal hides the mover's branding, as ConfirmedBanner does.
const app = useAppStore();

const contactName = computed(() => (app.hideBranding ? 'us' : app.tenantName || 'us'));
</script>
